import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

export const organizationsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "organizations",
  path: "/organizations",
  heading: { text: "Organisations", level: 1 },
  roles: {
    super_admin: "allow",
    admin: "allow",
    coach: "allow",
    company_admin: "allow",
    participant: "allow",
    cohort_lead: "allow"
  },
  states: ["loading", "ready", "empty", "error", "denied"],
  actions: [{ id: "load", kind: "secondary", driver: "page.load" }],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/organizations.tsx" },
  Component: ProductRouteScreenAdapter
});

export default organizationsScreenModule;
